export interface CropRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function isValidBox(box?: number[]): box is number[] {
  return (
    !!box &&
    box.length === 4 &&
    box.every((v) => typeof v === 'number' && Number.isFinite(v)) &&
    box[2] > 0 &&
    box[3] > 0
  );
}

// A tracker's person box can extend past the frame's edge. Cropping to the
// raw box sizes the window around pixels that don't exist, leaving dead
// space inside the crop, so intersect it with the image first. Null when the
// box lies entirely outside the frame.
export function clampBoxToImage(
  box: number[],
  image: { width: number; height: number }
): CropRect | null {
  const [x, y, w, h] = box;
  const left = Math.max(0, x);
  const top = Math.max(0, y);
  const right = Math.min(image.width, x + w);
  const bottom = Math.min(image.height, y + h);
  const width = right - left;
  const height = bottom - top;
  if (width <= 0 || height <= 0) {
    return null;
  }
  return { x: left, y: top, width, height };
}
